import React, { useEffect, useState } from "react";
import i18n from "i18next";

// Fabric Imports
import { fetchWrapper } from "../../helpers/fetchwrapper";

import { setAppState } from "../../store/actionCreators";
import { Dispatch } from "redux";
import { useDispatch } from "react-redux";

import { baseUrl } from "../../helpers/constants";
import { IAppStateDto } from "../../Models/IAppStateDto";
import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
} from "@fluentui/react-components";
import { Dismiss24Regular } from "@fluentui/react-icons";

interface IAddAllWearingPartsDialogProps {
  onDismiss: any;
  items: any;
}

function AddAllWearingPartsDialog(props: IAddAllWearingPartsDialogProps) {
  const addAllItemsToBedarfsListe = () => {
    fetchWrapper
      .post(`${baseUrl}/api/userbedarfe/addpositionen`, props.items)
      .then((result: any) => {
        refreshAppState();
        props.onDismiss();
      });
  };

  const dispatch: Dispatch<any> = useDispatch();

  const refreshAppState = () => {
    fetchWrapper
      .getWithAuth(`${baseUrl}/api/account/GetAppState`)
      .then((data: IAppStateDto) => {
        dispatch(setAppState(data));
      });
  };

  return (
    <Dialog modalType="modal" open={props.items.length > 0}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <div>{i18n.t<string>("addWearingParts")}</div>

              <Button
                onClick={() => {
                  props.onDismiss();
                }}
                appearance="transparent"
                icon={<Dismiss24Regular />}
              ></Button>
            </div>
          </DialogTitle>

          <DialogContent>
            <div>
              {i18n
                .t("addAllWearingPartsText")
                .replace("{0}", props.items.length)}
            </div>
          </DialogContent>

          <DialogActions>
            <Button
              appearance="primary"
              onClick={() => addAllItemsToBedarfsListe()}
            >
              {i18n.t<string>("commit")}
            </Button>

            <Button
              appearance="secondary"
              onClick={() => {
                props.onDismiss();
              }}
            >
              {i18n.t("cancel")}
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}

export default AddAllWearingPartsDialog;
